import type { UiPreferences } from "./useUiPreferences";

/**
 * Versandbearbeitung und Vorlagenpflege speichern ihre Arbeitsansicht unabhängig voneinander.
 * Beim Versand sind die echten Vorgangswerte standardmäßig sichtbar; die alte gemeinsame
 * Einstellung gilt weiterhin für die Vorlagenpflege, einschließlich ihrer Altwerte.
 */
export function documentPreviewValuesEnabled(
  prefs: UiPreferences,
  context: "template" | "send" = "template",
): boolean {
  const editors = prefs.documentEditors;
  if (context === "send") return editors?.sendPreviewValues ?? true;
  if (editors?.previewValues != null) return editors.previewValues;
  if (editors?.appearancePreviewValues === true || editors?.systemDocumentPreviewValues === true) return true;
  if (editors?.appearancePreviewValues === false || editors?.systemDocumentPreviewValues === false) return false;
  return true;
}
